module.exports = __webpack_public_path__ + "img/Event_7.ee3096fb.jpg";